/**
 * The latest operational data each BACnet/Modbus unit received over the websocket (real pushes and
 * optimistic ones). The Control screen hands panels and rows the entry it fetched on load, and they
 * only listen to pushes from the moment they mount - so without this, a unit opened after a change
 * shows the value from before it until the next push. Kept outside the store on purpose: pushes
 * arrive for every unit every minute, and nothing should re-render because of them.
 */

const BACNET_MESSAGE = 'UPDATE_BACNET_UNIT_DATA';
const MODBUS_MESSAGE = 'UPDATE_MODBUS_UNIT_DATA';

const latest = new Map<string, Record<string, any>>();

export const rememberOperationalData = (message: any) => {
  const { name, data } = message || {};
  if ((name !== BACNET_MESSAGE && name !== MODBUS_MESSAGE) || !data?.unitId || !data.operationalData) {
    return;
  }
  const unitId = String(data.unitId);
  // Modbus pushes full snapshots; BACnet pushes, and partial (optimistic) messages, only the points that changed
  const isFullSnapshot = name === MODBUS_MESSAGE && !data.partial;
  latest.set(unitId, isFullSnapshot ? { ...data.operationalData } : { ...(latest.get(unitId) || {}), ...data.operationalData });
};

/** The entry's operational data with whatever arrived over the websocket since it was fetched. */
export const withLatestOperationalData = (unitId: any, operationalData: Record<string, any> = {}) => {
  const received = unitId ? latest.get(String(unitId)) : undefined;
  return received ? { ...operationalData, ...received } : operationalData;
};
